export default "__VITE_ASSET__DoHe_083__"